import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../../elements/notification/Notification";
import RatesList from "./RatesList";
import RatesFilter from "./RatesFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";

import MaterialPagination from "../../styles/materialPagination";
import { StyledRatesWrapper } from "../styledRates";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import { AppContext } from "../../../App";
import RatesServiceEdit from "./RatesServiceEdit";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const RatesContainer = ({ type }) => {
  const [rates, setRates] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const { user } = useContext(AppContext);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", type, false, true),
    "rateBase.currency.asset": checkFilterItem(history, "rateBase.currency.asset", null),
    "connection.service.name": checkFilterItem(history, "connection.service.name", null),
    "connection.project.name": checkFilterItem(history, "connection.project.name", null),
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchRates = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/rates" + filterUrl + "&rateBase.currency.type=" + type, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setRates(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchRates();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };
  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledRatesWrapper>
        <div className="rates-head rates-head_client">
          <RatesFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
          <RatesServiceEdit
            currencyType={type}
            fetchRates={fetchRates}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <RatesList rates={rates} />
        {totalPageCount > 1  &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
      </StyledRatesWrapper>
    </>
  );
};

export default RatesContainer;